<template>
    <v-data-table
        dense
        :headers="headers"
        :footer-props="footer"
        :items="data"
        :loading="loading"
        :server-items-length="length"
        :options="options"
        @update:options="updateOptions"
    >
    <template v-slot:[`item.code`]="{item}">
        <v-btn icon @click="handleClickRow(item)" v-if="hasPermission(perm.credit_note.read)">
            <v-icon>mdi-magnify</v-icon>
        </v-btn>
        {{item.code}}
    </template>

    <template v-slot:[`item.amount`]="{item}">
        <span class="font-weight-bold">{{item.currency_abbreviation}}</span>
        {{formatNumber(item.amount, 2)}}
    </template>

    <template v-slot:[`item.state`]="{item}">
        <PStatus :state="item.state"/>
    </template>

    </v-data-table>
</template>

<script>
import permissions from './../../data/permissions';
import { mapActions, mapGetters } from 'vuex';
import PStatus from './../common/PStatus';
import { formatNumber } from 'accounting';

export default {
    name: "CreditNoteList",
    components: {
        PStatus
    },
    data() {
        return {
            footer: {
                'items-per-page-options': [10, 25, 50, 100]
            },
            headers: [
                { text: "Code", value: "code" },
                { text: "Date", value: "date" },
                { text: "Supplier", value: "supplier" },
                { text: "Amount", value: "amount" },
                { text: "Created By", value: "created_by"},
                { text: "State", value: "state" }
            ],
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            options: "purchase/creditNote/options",
            loading: "purchase/creditNote/loading",
            length: "purchase/creditNote/length",
            data: "purchase/creditNote/list",
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        formatNumber,
        ...mapActions({
            updateOptions: "purchase/creditNote/updateOptions"
        }),
        handleClickRow(item) {
            this.$router.push({name: "CreditNoteDisplay", params: {id: item.id}})
        }
    }
}
</script>

<style>

</style>